import { SUPPORTED_LEAGUES } from '../../types';

export const supportedLeagues = [
  SUPPORTED_LEAGUES.ALLSVENSKAN,
  SUPPORTED_LEAGUES.SUPERETTAN,
  SUPPORTED_LEAGUES.DAMALLSVENSKAN,
  SUPPORTED_LEAGUES.ELITETTAN,
];
